import { useState } from "react";
import { IconButton, Button, Grid } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { MDetalleGrupalStyle } from "./MDetalleGrupalStyle";
import { useDispatch, useSelector } from "react-redux";
import { obtenerDetalledGrupalAction } from "./../../../ducks/finanzasDuck"
import VisibilityIcon from '@material-ui/icons/Visibility';
import { formatDinero } from "./../../../utils/formatDinero"
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
});
const MDetalleGrupal = (props) => {
    const { Compra } = props
    const { detalleGrupo } = useSelector(store => store.finanzas)
    const classes = MDetalleGrupalStyle()
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch()
    const onClick = () => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDetalledGrupalAction({ idPagoGrupal: Compra.pagoGrupal?.idPagoGrupal })).then(Resposne => {
            dispatch(offLoadAction())
        })
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }
    return (
        <div>
            <IconButton variant="outlined" onClick={onClick}>
                <VisibilityIcon color="primary" />
            </IconButton>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo="Detalle del item"
                />
                <div style={{ height: "15rem", overflowY: "scroll" }}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="caption table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">#</TableCell>
                                    <TableCell align="center">Referencia</TableCell>
                                    <TableCell align="center">No. Pax.</TableCell>
                                    <TableCell align="center">Monto</TableCell>
                                    <TableCell align="center">Tipo compra</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {detalleGrupo.map((row, index) => (
                                    <TableRow key={row.Referencia}>
                                        <TableCell align="center">
                                            {index + 1}
                                        </TableCell>
                                        <TableCell align="center" >
                                            <ButtonClienteDetalle referencia={row.Referencia} />
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.Cantidad}
                                        </TableCell>
                                        <TableCell align="center">
                                            {formatDinero(row.Monto)}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.TipoCompra?.Descripcion}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                            onClick={handleClose}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBase>
        </div>
    )
}
export default MDetalleGrupal
